import Vue from 'vue'
import Router from 'vue-router'
import skyHome from "../components/home/index-sky";
import gtHome from "../components/home/Index-gt";

let Home;


process.env.BUILD_ENV === 'sky' ? Home = skyHome : Home = gtHome;

Vue.use(Router)

export default new Router({
  routes: [
		{
			path: '/',
			redirect: 'home'
		},
		{
			path: '/home',
			name: 'home',
			component: Home,
			children: [
				{
					path: '',
					redirect: '/map'
				},
				{
					path: '/map',
					name: 'map',
					component: resolve => require(['../components/map/Index.vue'], resolve)
				},
				{
					path: '/suggestion',
					name: 'suggestion',
					component: resolve => require(['../components/suggestion-collect/Index.vue'], resolve),
					children:[
						{
							path:'/suggestion',
							component: resolve => require(['../components/suggestion-collect/commit/SugList.vue'], resolve),
						},
						{
							path:'/suggestion/edit',
							component: resolve => require(['../components/suggestion-collect/commit/SugEdit.vue'], resolve),
						},
						{
							path:'/suggestion/manage',
							component: resolve => require(['../components/suggestion-collect/manage/SugManage.vue'], resolve),
						}
					]
				},
				{
				  path: '/multiScreen',
					component: resolve => require(['../components/map/multi-screen/MultiScreenView.vue'], resolve)
				},
				{
				  path: '/mapManage',
				  component: resolve => require(['../components/mapmanage/MapManage.vue'], resolve)
				},
				{
					path:'/scene',
					name:'scene',
					component: resolve => require(['../components/scene/SimpleScene.vue'], resolve)
				}

			]
		},
		{
			path: '/resourceRel',
			name: 'resourceRel',
			component: resolve => require(['../components/resourcerelmanage/Index.vue'], resolve)
		},
    {
      path: '/elementLink',
      component: resolve => require(['@/components/elementLink/Index'], resolve)
    },
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js